import React, { Component } from 'react';
import Notifications2, {notify} from 'react-notify-toast';
import InputMask from 'react-input-mask';
import Dropzone from 'react-dropzone';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';
import { connectionGet, connectionPost } from '../../utils/connection';

@inject('userStore')
class Importer extends Component {
    constructor(props){
      super(props);
      this.state = {
        business:null,
        files:[],
        uploadVisible:false,
        results:[]
      }
    }

    componentDidMount(){
      this.fetchBusiness(this.props.userStore.business_primary.hash_id);
    }

    fetchBusiness = (hash_id) => {
      post('/v2/get/business', {business_hash_id: hash_id},{
        auth: {username: this.props.userStore.token}
      }).then((res) => {
        this.setState({
          business:res.data.business
        });
      }).catch((error) => {
        console.log(error);
        return error;
      });
    }

    saveEvents = () => {
      // connectionPost('import-event', {booking: this.state.results[0]}, {username: this.props.userStore.token})
      // .then((res) => {
      //   if (res.data.errors === 0){
      //     // update the row
      //     let tmpResults = Object.assign([], this.state.results);
      //     let index = tmpResults.findIndex(x => x.id === res.data.event.id);
      //     tmpResults[index] = res.data.event;
      //     this.setState({
      //       results:tmpResults
      //     })
      //   }
      // }).catch((error) => {
      //   console.log(error);
      //   return error;
      // });
      //
      this.state.results.map((result,i)=>{
        connectionPost('import-event', {booking: result}, {username: this.props.userStore.token})
        .then((res) => {
          if (res.data.errors === 0){
            // update the row
            let tmpResults = Object.assign([], this.state.results);
            let index = tmpResults.findIndex(x => x.id === res.data.event.id);
            tmpResults[index] = res.data.event;
            this.setState({
              results:tmpResults
            })
          }
        }).catch((error) => {
          console.log(error);
          return error;
        });
      })
    }

    fileUpload = () => {
      const formData = new FormData();
      formData.append('file',this.state.files[0])
      post('/v2/uploader/' + this.state.business.hash_id, formData,{
        auth: {username: this.props.userStore.token}
      }).then((res) => {
        if (res.data.errors === 0){
          console.log(res.data);
          // let removedEl = res.data.results.shift();
          this.setState({
            results:res.data.results
          },()=>console.log(this.state.results))
        }
      }).catch((error) => {
        console.log(error);
        return error;
      });
    }

    onDrop = (files) => {
      console.log(files)
      this.setState({
        files:files
      }, ()=>this.fileUpload());
    }

    openUpload = () => {
      this.setState({
        uploadVisible:!this.state.uploadVisible
      })
    }


    render(){
      const dropzone = {
          'position': 'relative',
          'width': '200px',
          'height': '200px',
          'borderWidth': '2px',
          'borderColor': 'rgb(102, 102, 102)',
          'borderStyle': 'dashed',
          'borderRadius': '5px',
          marginTop: '15px',
          marginRight: 'auto',
          marginBottom: 0,
          marginLeft: 'auto',
      };
      if (!this.state.business) return <div className="alert alert-info">Loading...</div>;
      const {business, results} = this.state;
      return (
      <React.Fragment>
        <div className="card form-type-combine">
          <h4 className="card-title"><strong>Events Uploader</strong></h4>
          <div className="card-body">
            <div className="card card-inverse mb-0">
              <Dropzone
                  multiple={false}
                  onDrop={this.onDrop}
                  style={dropzone}
                  onFileDialogCancel={this.onCancel}>
                  <p>Drop csv file here, or click to select file to upload.</p>
              </Dropzone>
            </div>
            <h4 className="card-title"><strong>Results</strong></h4>
            <div className="card-body">
              <div className="col-12">
              {results.length > 0 ? (
                <React.Fragment>
                <button className="btn btn-primary" type="button" onClick={this.saveEvents}>Import</button>
                <table className="table table-striped table-condensed table-responsive">
                  <tbody>
                {results.map((result, index)=>
                  <tr key={index}>
                    {Object.keys(result).map((key, index) => {
                      if (key === 'saved'){
                        let saved = 'NO'
                        if (result[key] === 1){
                          saved = 'YES'
                        }
                        return (<td key={index}>{saved}</td>);
                      } else {
                        return (<td key={index}>{result[key]}</td>);
                      }
                    })}
                  </tr>
                )}
                  </tbody>
                </table>
                </React.Fragment>
              )
              : null}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
      );
    }
}

export default Importer;



// WEBPACK FOOTER //
// ./src/components/business/Importer.js